import {RepositoryFactory} from '@/repositories/RepositoryFactory';

const PrintingDiyRepository = RepositoryFactory.get('printingDiy');

// action names
export const USER_GET_LIST = 'USER_GET_LIST';
export const USER_RESET_LIST = 'USER_RESET_LIST';
export const USER_SET_FILTER = 'USER_SET_FILTER';
export const USER_SET_EDIT_USER = 'USER_SET_EDIT_USER';
export const USER_RESET_EDIT_USER = 'USER_RESET_EDIT_USER';

const SET_LIST = 'SET_LIST';
const SET_PAGE = 'SET_PAGE';
const SET_FILTER = 'SET_FILTER';
const SET_EDIT_USER = 'SET_EDIT_USER';
const RESET_EDIT_USER = 'RESET_EDIT_USER';

const getInitEdit = () => ({
    userId: null,
    name: null,
    description: null,
    phone: null,
    imagePath: null,
    lastLogin: null,
    createdAt: null,
    updatedAt: null,
    isValid: true,
    permissions: [],
});

const getInitState = () => ({
    list: [],
    totalCount: 0,
    page: 1,
    pageSize: 20,
    filters: {
        userId: null,
        name: null,
        phone: null,
        isValid: null,
    },
    isAddMode: true,
    edit: getInitEdit(),
});

const makeQuery = state => {
    const filters = state.filters;
    const query = {
        page: state.page,
        pageSize: state.pageSize,
    };

    if (filters.userId) {
        query.userId = filters.userId;
    }

    if (filters.name) {
        query.name = filters.name;
    }

    if (filters.phone) {
        query.phone = filters.phone;
    }

    if (filters.isValid !== null) {
        query.isValid = filters.isValid ? 1 : 0;
    }

    return query;
};

const getters = {};

const actions = {
    [USER_GET_LIST]: async ({state, commit}, page) => {
        commit(SET_PAGE, page);
        const query = makeQuery(state);
        const {data} = await PrintingDiyRepository.getUsers(query);
        commit(SET_LIST, data);
    },
    [USER_RESET_LIST]: async ({commit}) => {
        commit(SET_LIST, {list: [], totalCount: 0});
    },
    [USER_SET_FILTER]: async ({commit}, {key, value}) => {
        commit(SET_FILTER, {key, value});
    },
    [USER_SET_EDIT_USER]: async ({commit}, user) => {
        commit(SET_EDIT_USER, user);
    },
    [USER_RESET_EDIT_USER]: async ({commit}) => {
        commit(RESET_EDIT_USER);
    },
};

const mutations = {
    [SET_LIST]: (state, {list, totalCount}) => {
        state.list = list;
        state.totalCount = totalCount;
    },
    [SET_PAGE]: (state, page) => {
        state.page = page;
    },
    [SET_FILTER]: (state, {key, value}) => {
        state.filters[key] = value;
    },
    [SET_EDIT_USER]: (state, {userId, name, description, phone, imagePath, lastLogin, createdAt, updatedAt, isValid, permissions}) => {
        state.isAddMode = false;
        state.edit = {
            userId,
            name,
            description,
            phone,
            imagePath,
            lastLogin,
            createdAt,
            updatedAt,
            isValid,
            permissions,
        };
    },
    [RESET_EDIT_USER]: (state) => {
        state.isAddMode = true;
        state.edit = getInitEdit();
    },
};

export default {
    state: getInitState(),
    getters,
    actions,
    mutations,
};